import { formatNumber } from './utils/text';

const EMAIL_CAPTURE_TOOLTIP_CONTENT_GENERATOR = (value: number) => {
  if (value <= 0) {
    return 'This Journey has not captured any emails';
  }
  return `${formatNumber(value)} recipient${value !== 1 ? 's' : ''} ${
    value !== 1 ? 'have' : 'has'
  } left their email while viewing this Journey`;
};

const CTA_CLICK_CONTENT_GENERATOR = (value: number) => {
  if (value <= 0) {
    return 'No CTA button was clicked';
  }
  return `${formatNumber(value)} CTA click${value !== 1 ? 's' : ''}`;
};

const JOURNEY_VIEW_TOOLTIP_CONTENT_GENERATOR = (value: number) => {
  if (value <= 0) {
    return 'This Journey has never been opened';
  }
  return `This Journey has been opened ${formatNumber(value)} time${value !== 1 ? 's' : ''}`;
};

const VIEW_TOOLTIP_CONTENT_GENERATOR = (value: number) => {
  if (value <= 0) {
    return 'This Journey has never been viewed';
  }
  return `${formatNumber(value)} step${value !== 1 ? 's' : ''} ${
    value !== 1 ? 'have' : 'has'
  } been viewed by recipients`;
};

export const JOURNEY_OPENS_CARD = {
  key: 'journey_view',
  filter: (r: any) => r.event_type === 'journey_view',
  title: 'Journey opens',
  tooltipContentCreator: JOURNEY_VIEW_TOOLTIP_CONTENT_GENERATOR,
  valueCreator: (v: number) => `${formatNumber(v)}`,
};
export const STEPS_VIEWED_CARD = {
  key: 'view',
  filter: (r: any) => r.event_type === 'view',
  title: 'Steps viewed',
  tooltipContentCreator: VIEW_TOOLTIP_CONTENT_GENERATOR,
  valueCreator: (v: number) => `${formatNumber(v)}`,
};
export const EMAILS_CAPTURED_CARD = {
  key: 'email_capture',
  filter: (r: any) => r.event_type === 'email_capture',
  title: 'Emails captured',
  tooltipContentCreator: EMAIL_CAPTURE_TOOLTIP_CONTENT_GENERATOR,
  valueCreator: (v: number) => `${formatNumber(v)}`,
};

export const CTA_CLICKS_CARD = {
  key: 'cta_click',
  filter: (r: any) => r.event_type === 'cta_click',
  title: 'CTA clicks',
  tooltipContentCreator: CTA_CLICK_CONTENT_GENERATOR,
  valueCreator: (v: number) => `${formatNumber(v)}`,
};

export const EMAIL_GATE_NODE_ACTIONS: any = {
  journey: { action: 'view', obj: 'Journey' },
  video: { action: 'watch', obj: 'video' },
  loom: { action: 'watch', obj: 'video' },
  youtube: { action: 'watch', obj: 'video' },
  vimeo: { action: 'watch', obj: 'video' },
  google_slides: { action: 'view', obj: 'presentation' },
  pitch: { action: 'view', obj: 'presentation' },
  canva: { action: 'view', obj: 'presentation' },
  pdf: { action: 'view', obj: 'file' },
  iframe: { action: 'view', obj: 'page' },
};
